import { PaymentContextType } from './types';

// @ts-ignore
export const DEFAULT_CONTEXT_VALUES: PaymentContextType = {
    timerTime: 0,
};
